import { useCallback } from 'react';
import { MediaSegment } from 'redux/modules/entities';
import { addGapsToTime, removeGapsFromTime } from 'utils/embed/media-segment';
import { millisToSec, secToMillis } from 'utils/time';

export type UseCurrentTimeProps = {
  segments?: MediaSegment[];
  videoRef: React.RefObject<HTMLVideoElement>;
};

/**
 * Get and set the current time, accounting for gaps
 */
export default function useCurrentTime({
  segments,
  videoRef,
}: UseCurrentTimeProps) {
  const setCurrentTime = useCallback(
    (sec: number) => {
      const actualMillis = addGapsToTime(secToMillis(sec), segments);
      videoRef.current.currentTime = millisToSec(actualMillis);
    },
    [segments, videoRef],
  );

  const getCurrentTime = useCallback(() => {
    const actualMillis = secToMillis(videoRef.current?.currentTime);
    const displayMillis = removeGapsFromTime(actualMillis, segments);
    return millisToSec(displayMillis);
  }, [segments, videoRef]);

  return { setCurrentTime, getCurrentTime };
}
